import * as bookMark from 'services/bookMark';

export const BOOKMARK_ADD = 'BOOKMARK_ADD';
export const BOOKMARK_LIST = 'BOOKMARK_LIST';
export const BOOKMARK_DEL = 'BOOKMARK_DEL';

export const Add = (params) => ({
  type: BOOKMARK_ADD,
  payload: {
    promise: bookMark.Add(params)
  }
});

export const List = () => ({
  type: BOOKMARK_LIST,
  payload: {
    promise: bookMark.List()
  }
});

export const Del = (params) => ({
  type: BOOKMARK_DEL,
  payload: {
    promise: bookMark.Del(params)
  }
});
